export const SET_STATE = 'menus/SET_STATE';
export const SET_FETCHING = 'menus/SET_FETCHING';
export const SET_MENU = 'menus/SET_MENU';
export const RESET_STATE = 'menus/RESET_STATE';
